import React from "react";
import {
  Heading,
  Box,
  Accordion,
  Button,
  UnorderedList,
  ListItem,
  Flex,
  Tooltip,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuDivider,
  MenuList,
  Center,
  Text,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Portal,
  CheckboxGroup,
  Stack,
  Checkbox,
  Spinner
} from "@chakra-ui/react";
import ReactDragListView from "react-drag-listview/lib/index.js";
import { NavLink } from "react-router";
import { COURSE, PUBLISHED, MONTHLY, YEARLY, SUBSCRIPTION, ONETIMEPURCHASE } from "../../constants";
import { Module } from "../../components/Module";
import { ModalBox } from "../../components/ModalBox";
import { DropDragIcon } from "../../components/Icons/DropDragIcon";
import { Tree } from "../../components/Tree";
import { openViewer } from "../../utils/helper";
import { useContent } from "./useContent"
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { LockIcon, UnlockIcon, ExternalLinkIcon } from '@chakra-ui/icons'
import { ResourcesPage } from "../ResourcesPage";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider";
import "./ContentPage.scss";
import { HelmetComponent } from "../../components/HelmetComponent";
import { ProductInfo } from "../../components/ProductInfo";
import { FormRadio } from "../../components/FormRadio";
import { FormSelect } from "../../components/FormSelect";
import { FormInput } from "../../components/FormInput";
import { Pagination } from "../../components/Pagination";
import { DynoIcon } from "../../components/DynoIcon";
import { Search } from "../../components/Search";

export const ContentPage = () => {

  const {
    publisher,
    catalogs,
    product,
    publishStatus,
    isAdmin,
    canProductBePublished,
    showViewer,
    isOpen,
    onOpen,
    onClose,
    isDynoModalOpen,
    onDynoModalClose,
    createNewChapter,
    lockUnlockAllDyno,
    updateChapterListOrder,
    deleteCallback,
    openAddDynoModal,
    updatDynoStatusCallback,
    updateDynoListCallback,
    onChangeLock,
    updatDynoAccessType,
    checkOnChange,
    addDynoToList,
    publishProduct,
    productId,
    editCallback,
    deleteDynoCallback,
    archiveProduct,
    addToStore,
    loading,
    createMediaDynoCallback,
    isAddMediaModalOpen,
    onAddMediaModelClose,
    onMediaModalOpen,
    media,
    selectMedia,
    user,
    onOpenAddPlan,
    onCloseAddPlan,
    isOpenAddPlan,
    createPricePlan,
    handleChange,
    pricePlan,
    showButton,
    onAddMediaClose,
    myDynoesLoading,
    currentPage,
    totalDynoes,
    PageSize,
    onPageChange,
    searchText,
    currentDynosList,
    searchTextCallback,
    searchedDynoes,
    searchMyDynoesLoading
  } = useContent();

  const { addBreadcrumb } = useBreadcrumbs()
  return (
    <>
      <HelmetComponent title={`Content - Home - ${user.firstName} ${user.lastName}`} />
      {loading && <LoadingOverlay />}
      <Flex justifyContent="flex-end" alignItems="center" gap={3}>
        {showViewer && showButton ?
          <Tooltip label={`Preview the ${product.productType}`} hasArrow bg='gray.700'>
            <a href={openViewer(productId)} target="_blank" rel="noreferrer">
              <Button colorScheme="blue" variant="outline" fontSize="14px" size='sm'>Preview {product.productType}<ExternalLinkIcon ml={1} /></Button>
            </a>
          </Tooltip> : <></>
        }
        {isAdmin && product?.catalog?.id && (
          <Tooltip label="Update product information" hasArrow bg='gray.700'>
            <NavLink to={product.productType === COURSE ? `/updatecourse/${product.id}/${product.catalog.id}` : `/updatebook/${product.id}/${product.catalog.id}`}>
              <Button colorScheme="blue" fontSize="14px" size='sm'>Update Product Information</Button>
            </NavLink>
          </Tooltip>
        )}
      </Flex>
      <ProductInfo product={product} mt="20px" />
      <Box bg="white" p={6} rounded="lg" shadow="md" mt={5}>
        <Box display="flex" justifyContent="flex-end" mb="20px">
          {isAdmin && showButton ?
            <>
              <Tooltip label={`${product.productStatus === "Offline" ? `Publish the ${product.productType}, If all the EdDoc of all the ${product.productType === "book" ? "chapters" : "modules"} are "Verified By QA"` : `Unpublish the ${product.productType}`}`} hasArrow bg='gray.700'>
                <Button
                  onClick={onOpen}
                  colorScheme="blue"
                  sx={{ marginRight: "20px", fontSize: "14px" }}
                  disabled={!canProductBePublished || !product.productPricingType}
                  size='sm'
                >
                  {product.productStatus === "Offline" ? "Publish" : "Unpublish"}{" "}
                </Button>
              </Tooltip>
              {
                !product?.productPricingType ?
                  publisher?.stripeAccountId ?
                    <>
                      <Tooltip label={`Adds the pricing plan.`} hasArrow bg='gray.700'>
                        <Button
                          onClick={onOpenAddPlan}
                          colorScheme="blue"
                          sx={{ marginRight: "20px", fontSize: "14px" }}
                          size='sm'
                        >Add Pricing</Button>
                      </Tooltip>
                    </>
                    :
                    <Popover>
                      <PopoverTrigger>
                        <Box>
                          <Tooltip label="Adds the pricing plan." hasArrow bg="gray.700">
                            <Button
                              colorScheme="blue"
                              sx={{ marginRight: "20px", fontSize: "14px" }}
                              size="sm"
                            >
                              Add Pricing
                            </Button>
                          </Tooltip>
                        </Box>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverHeader color="blue.500">Create Stripe Connect Account</PopoverHeader>
                          <PopoverCloseButton />
                          <PopoverBody>
                            <Text>It seems that you have not completed the onBoarding.</Text>
                            <Button
                              as={NavLink}
                              to="/manageaccount"
                              onClick={() => addBreadcrumb("OnBoarding Steps", "/manageaccount", true)}
                              colorScheme="blue"
                              mt={2}
                            >
                              Go to Onboarding Page
                            </Button>
                          </PopoverBody>
                        </PopoverContent>
                      </Portal>
                    </Popover> : <></>
              }
              {
                product.productStatus !== "Offline" && !product.isAddedToStore && product?.productPricingType ?
                  publisher?.stripeAccountId ?
                    <Tooltip label={`Adds the product to store.`} hasArrow bg='gray.700'>
                      <Button
                        onClick={() => addToStore(product, true)}
                        colorScheme="green"
                        sx={{ marginRight: "20px", fontSize: "14px" }}
                        size='sm'
                      >
                        Add To Store
                      </Button>
                    </Tooltip> :
                    <Popover>
                      <PopoverTrigger>
                        <Tooltip label={`Adds the product to store if pricing plan is added.`} hasArrow bg='gray.700'>
                          <Button
                            colorScheme="green"
                            sx={{ marginRight: "20px", fontSize: "14px" }}
                            size='sm'
                          >
                            Add To Store
                          </Button>
                        </Tooltip>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverHeader color="blue.500">Create Stripe Connect Account</PopoverHeader>
                          <PopoverCloseButton />
                          <PopoverBody>
                            <Text>It seems that you have not completed the onBoarding.</Text>
                            <NavLink to="/manageaccount" onClick={() => addBreadcrumb("OnBoarding Steps", "/manageaccount", true)} end><Button colorScheme='blue' mt={2}>Go to Onboarding Page</Button></NavLink>
                          </PopoverBody>
                        </PopoverContent>
                      </Portal>
                    </Popover>
                  : <></>
              }
              {product.isAddedToStore ?
                <Tooltip label={`Removes the product from store. Once it is removed the product will no longer be visible in your website`} hasArrow bg='gray.700'>
                  <Button
                    onClick={() => addToStore(product, false)}
                    colorScheme="red"
                    sx={{ marginRight: "20px", fontSize: "14px" }}
                    size='sm'
                  >
                    Remove From Store
                  </Button>
                </Tooltip> : <></>
              }
            </> :
            <></>
          }
          {isAdmin && !publishStatus && (
            <>
              {
                product.productContent.dynoList.length !== 0 ?

                  <Tooltip label="Create a module" hasArrow bg='gray.700'>
                    <Button
                      colorScheme="blue"
                      sx={{ marginRight: "20px", fontSize: "14px" }}
                      onClick={createNewChapter}
                      size='sm'
                    >
                      Create New Module
                    </Button>
                  </Tooltip>
                  : <></>
              }
              {product.productType === COURSE && showButton && (
                <>
                  <Tooltip label="Lock all EdDoc" hasArrow bg='gray.700'>
                    <IconButton
                      onClick={() => lockUnlockAllDyno(true)}
                      sx={{ marginRight: "20px", fontSize: "14px" }}
                      colorScheme="blue"
                      icon={<LockIcon />}
                      aria-label='Lock all EdDoc'
                      size='sm'
                    />

                  </Tooltip>
                  <Tooltip label="Unlock all EdDoc" hasArrow bg='gray.700'>
                    <IconButton
                      onClick={() => lockUnlockAllDyno(false)}
                      sx={{ marginRight: "20px", fontSize: "14px" }}
                      colorScheme="blue"
                      icon={<UnlockIcon />}
                      aria-label='Unlock all EdDoc'
                      size='sm'
                    />
                  </Tooltip>
                </>
              )}
              <Menu>
                <Tooltip label="More Action" hasArrow bg='gray.700'>
                  <MenuButton>
                    <Image src="/images/menu-vertical.svg" width="20px" height="20px" />
                  </MenuButton>
                </Tooltip>
                <MenuList>
                  {
                    product.productStatus === "Offline" ?
                      <>
                        <MenuItem onClick={() => archiveProduct(product)} color="red.500">
                          Archive
                        </MenuItem>
                      </> : <></>
                  }
                </MenuList>
              </Menu>
            </>
          )}
        </Box>
        {
          isAdmin && product.productContent.dynoList.length === 0 ?
            <Center height="calc(100vh - 260px)">
              <Tooltip label="Create a module" hasArrow bg='gray.700'>
                <Button
                  colorScheme="blue"
                  sx={{ marginRight: "20px", fontSize: "14px" }}
                  onClick={createNewChapter}
                  size='sm'
                >
                  Create New Module
                </Button>
              </Tooltip>
            </Center> : <></>
        }
        <Accordion defaultIndex={[0]} allowMultiple>
          <ReactDragListView
            nodeSelector="li.chapter-list-item"
            handleSelector="button.chapter-list-order-button"
            onDragEnd={(fromIndex, toIndex) =>
              updateChapterListOrder(fromIndex, toIndex)
            }
          >
            <UnorderedList listStyleType="none" marginInlineStart="0">
              {product.productContent.dynoList.map((list) => (
                <ListItem
                  key={list.id}
                  position="relative"
                  className="chapter-list-item"
                >
                  {isAdmin && product.productStatus !== "Published" && (
                    <Button
                      className="chapter-list-order-button"
                      variant="ghost"
                      position="absolute"
                      top="12px"
                      left="-20px"
                      padding="0"
                      cursor="grab"
                      _hover={{
                        background: "none",
                      }}
                    >
                      <DropDragIcon />
                    </Button>
                  )}
                  <Module
                    id={list.id}
                    listId={list.id}
                    listName={list.listName}
                    dynosList={list.dynosUnderList}
                    isContentPage={true}
                    editCallback={(value) => editCallback(list.id, value)}
                    deleteCallback={() => deleteCallback(list.id, list.listName)}
                    createMediaDynoCallback={(media) => createMediaDynoCallback(media)}
                    modalTitle="Remove EdDoc"
                    deleteDynoCallback={(id, dyno) =>
                      deleteDynoCallback(list.id, id, dyno)
                    }
                    openAddDynoModal={() => openAddDynoModal(list.id)}
                    updatDynoStatusCallback={updatDynoStatusCallback}
                    updateDynoListCallback={(data) =>
                      updateDynoListCallback(list.id, data)
                    }
                    isAdmin={isAdmin}
                    publishStatus={publishStatus}
                    onChangeLock={onChangeLock}
                    productType={product.productType}
                    updatDynoAccessType={updatDynoAccessType}
                    onMediaModalOpen={() => onMediaModalOpen(list.id)}
                  />
                </ListItem>
              ))}
            </UnorderedList>
          </ReactDragListView>
        </Accordion>
      </Box>
      <ModalBox
        title={`${product.productStatus === "Offline" ? "Publish" : "Unpublish"
          } ${product.productName}`}
        description={`Are you sure you want to ${product.productStatus === "Offline" ? "Publish" : "Unpublish"
          } ${product.productName}`}
        isOpen={isOpen}
        onClose={onClose}
        isDeleteButton={false}
        isFooter={true}
        confirmButtonText={
          product.productStatus === "Offline" ? "Publish" : "Unpublish"
        }
        cancelButtonText="Cancel"
        onConfirm={publishProduct}
        onCancel={onClose}
      />
      <ModalBox
        title="Add EdDoc"
        description={
          (myDynoesLoading || searchMyDynoesLoading) ?
          <Center><Spinner /></Center> :
          <Box>
            <Search
              placeholder="Search EdDoc"
              searchName={searchText}
              searchTextCallback={searchTextCallback}
            />
            <CheckboxGroup>
              <Stack spacing={[1, 5]} direction={['column']}>
                  {
                    searchText !== "" ?
                      searchedDynoes.map(dyno => (
                        <Checkbox value={JSON.stringify(dyno)} onChange={checkOnChange}>
                          <Flex><DynoIcon dynoType={dyno.dynoType.name} /><Text as="span" ml={2}>{dyno.dynoTitle}</Text></Flex>
                        </Checkbox>
                      )) : currentDynosList.map(dyno => (
                        <Checkbox value={JSON.stringify(dyno)} onChange={checkOnChange}>
                          <Flex alignItems="center"><DynoIcon dynoType={dyno.dynoType.name} /><Text as="span" ml={2}>{dyno.dynoTitle}</Text></Flex>
                        </Checkbox>
                      ))
                  }
              </Stack>
            </CheckboxGroup>
            {searchText !== "" && searchedDynoes.length === 0 && (
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Text fontSize="lg">
                    No search found for the {searchText}
                  </Text>
                </Box>
            )}
            <Box mt={3}>
              {searchText === "" && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={totalDynoes}
                    pageSize={PageSize}
                    onPageChange={onPageChange}
                  />
                )}
            </Box>
          </Box>
        }
        size="xl"
        styleProps={{
          maxWidth: "600px",
        }}
        isOpen={isDynoModalOpen}
        onClose={onDynoModalClose}
        isDeleteButton={false}
        isFooter={true}
        confirmButtonText="Add"
        cancelButtonText="Cancel"
        onConfirm={addDynoToList}
        onCancel={onDynoModalClose}
      />
      <ModalBox
        title="Select file"
        isOpen={isAddMediaModalOpen}
        onClose={onAddMediaClose}
        isFooter={true}
        onCancel={onAddMediaClose}
        confirmButtonType={true}
        onConfirm={() => createMediaDynoCallback(media)}
        confirmButtonText="Select"
        size="full"
        isHideDivider={true}
        description={
          <ResourcesPage type="videos" isHideFilter={false} isSelection={true} url={media.url} selectMedia={selectMedia} isFromContentPage={true} />
        }
      ></ModalBox>
      <ModalBox
        title="Plan"
        description={
          <form onSubmit={createPricePlan}>
            <FormRadio
              name="Pricing type"
              radioGroupName="pricingType"
              value={pricePlan?.type}
              onChange={(value) => handleChange({ target: { name: "type", value: value } })}
              array={[SUBSCRIPTION, ONETIMEPURCHASE]}
              isRequired={true}
              padding={{ base: "0 0 10px" }}
            />
            {
              pricePlan?.type === SUBSCRIPTION ?
                <FormSelect
                  formProps={{
                    isRequired: true,
                  }}
                  label="Frquency"
                  value={pricePlan?.frequency}
                  selectOnChange={handleChange}
                  options={[{ id: 1, name: YEARLY, value: YEARLY }, { id: 2, name: MONTHLY, value: MONTHLY }]}
                  name="frequency"
                  padding={{ base: "0 0 10px" }}
                /> : <></>
            }
            <FormInput
              label="Price"
              name="price"
              type="text"
              inputOnChange={handleChange}
              value={pricePlan?.price}
              formProps={{ isRequired: true }}
              padding={{ base: "0 0 20px" }}
            />
            <Flex justifyContent="flex-end">
              <Button type="submit" colorScheme="blue">Create</Button>
            </Flex>
          </form>
        }
        isOpen={isOpenAddPlan}
        onClose={onCloseAddPlan}
        isFooter={false}
      />
    </>
  );
};
